import React from "react";
import classes from "./QuizItem.module.css";

const QuizItem = (props) => {
  const { text, logo } = props.moduleValues;
  return (
    <div
      onClick={() => props.selectModule(props.moduleName)}
      className={classes.QuizItem}
    >
      <span>
        <i className={logo}></i>
      </span>
      <h3 className={classes.Title}>{text}</h3>
    </div>
  );
};

export default QuizItem;
